import { defineMessages } from 'react-intl-next';

export default defineMessages({
	joinProductTitle: {
		id: 'project-pages.cross-join.inline-join-product.connected.title',
		defaultMessage: 'Collaborate on project pages with your team',
		description:
			'Title encouraging users to join Confluence when there is a connected Confluence space',
	},
	joinProductDescription: {
		id: 'project-pages.cross-join.inline-join-product.connected.description',
		defaultMessage: 'View, edit and create documentation from a single place',
		description: 'Value prop for joining Confluence when there is a connected Confluence space',
	},
	joinProductButton: {
		id: 'project-pages.cross-join.inline-join-product.button',
		defaultMessage: 'Join',
		description: 'Button label for joining Confluence CTA',
	},
	joinProductButtonDescription: {
		id: 'project-pages.cross-join.inline-join-product.button',
		defaultMessage: 'You’ll get access to Confluence. Your site admin has already approved you.',
		description: 'Button label for joining Confluence CTA',
	},
});
